import { useEffect, useState } from 'react';
import apis from '@src/apis';

// The system caption styles from `GET /caption-templates`.
let pending = null;

const requestTemplates = async () => {
  try {
    const response = await apis.captionTemplate.getCaptionTemplates();
    const templates = response?.result?.captionTemplates || [];
    if (!templates.length) pending = null;
    return templates;
  } catch {
    pending = null;
    return [];
  }
};

const fetchTemplates = () => {
  if (!pending) pending = requestTemplates();
  return pending;
};

const useCaptionTemplates = () => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetchTemplates().then((list) => {
      if (!cancelled) setTemplates(list);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return templates;
};

export default useCaptionTemplates;
